/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import OzFormComponent from './OzFormComponent';
import { AutocompleteField } from './EscapeForm';
import { colorForRating, borderColorForRating } from './PercentBar';
import PercentBar from './PercentBar';
import './ReviewForm.css';

import {
  upload,
  getSuggestions,
} from '../../actions';

export const ratingFields = [
  ['puzzles', 'Puzzles', 'How interesting and original were the puzzles?'],
  ['immersion', 'Immersion', 'Was the room immersive and on-theme?'],
  ['difficulty', 'Difficulty', 'How hard was it to solve this room?'],
];

function ucFirst(string)  {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export class DetailRating extends Component {
  setRating(field, rating) {
    if (this.props.onSetRating) {
      this.props.onSetRating(field, rating);
    }
  }

  render() {
    let rf = this.props.ratingField;

    let key = rf[0];
    let short = rf[1];
    let long = rf[2];
    let field = 'rating' + ucFirst(key);

    let rangeNodes = [];
    let range = 5;
    let rating = this.props.data[field] || null;

    if (!rating && this.props.noEmpty) return null;

    for (let i = 0; i < range; i++) {
      let active = rating && rating >= i + 1;
      let rangeNode = (
        <div
          key={i}
          onClick={() => this.setRating(field, i + 1)}
          className={cx('detail-rating-star', { active })}
          >
          {active && <span><FontAwesome name="check" /></span>}
        </div>
      );
      rangeNodes.push(rangeNode);
    }

    return (
      <div className="DetailRating">
        <div className="detail-rating">
          <div className="header-short">{short}</div>
          {!this.props.noLong && <div className="header-long">{long}</div>}
          <div className="rating-options">
            <div className="ratings-wrapper">{rangeNodes}</div>
          </div>
        </div>
      </div>
    );
  }
}


class ReviewForm extends OzFormComponent {

  static fields = [
    'escapeId',
    'roomId',
    'stars',
    'body',
    'bodySpoilers',
    'percent',
    'ratingPuzzles',
    'ratingImmersion',
    'ratingScary',
    'ratingDifficulty',
  ];

  constructor(props) {
    super(props);
    this.state.room = props.room;
  }

  componentDidMount() {
    setTimeout(() => {
      this.setPercent(this.state.percent);
    }, 200);
  }

  room() {
    return this.state.room;
  }

  setStep(step) {
    this.setState({ step });
  }

  step() {
    let step = 'stars';
    if (this.state.percent) {
      step = 'ratings';
    }
    if (this.state.step) {
      step = this.state.step;
    }
    return step;
  }

  ratingMove(e) {
    if (!this.state.dragging) return;
    this.updateHoversFrom(e.clientX);
  }

  updateHoversFrom(clientX) {
    let width = this.refs.bar.getBoundingClientRect().width;
    let left = this.refs.bar.getBoundingClientRect().left
    let percent = (clientX - left) / width;

    console.log('WIDTH', width);
    console.log('percent', percent);

    let hoverPercent = Math.round(100 * percent);
    if (hoverPercent < 1) {
      hoverPercent = 1;
      percent = .01;
    }
    if (hoverPercent > 100) {
      hoverPercent = 100;
      percent = 1;
    }

    this.setState({
      hoverPercent,
      hoverWidth: (percent * width) - barPadding,
    });
  }

  ratingClick() {
    this.setState({
      percent: this.state.hoverPercent,
      width: this.state.hoverWidth,
    });
  }

  startTouch(e) {
    e.preventDefault();
    this.touching = true;
  }

  moveTouch(e) {
    this.updateHoversFrom(e.touches[0].clientX);
  }

  endTouch(e) {
    this.touching = false;
    this.endDrag(e);
  }

  startDrag(e) {
    if (this.touching) return;

    e.preventDefault();
    console.log('start drag', e);

    this.setState({ dragging: true });
    this.updateHoversFrom(e.clientX);
    let fnMove = (e) => {
      this.ratingMove(e);
    };
    let fnUp = (e) => {
      this.endDrag(e);
      window.removeEventListener('mouseup', fnUp, false);
      window.removeEventListener('mousemove', fnMove, false);
    };
    window.addEventListener('mouseup', fnUp, false);
    window.addEventListener('mousemove', fnMove, false);
  }

  endDrag(e) {
    e.preventDefault();
    this.ratingClick();
    this.setState({ hoverPercent: 0, hoverWidth: 0, dragging: false });
  }

  setPercent(percent) {
    console.log('debug set percent', percent);
    this.setState({ percent: percent });
  }

  renderStars() {
    let room = this.room();

    console.log('debug initial percent', this.state.percent);

    return (
      <div>
        <p>
          How would you rate your overall experience with <b>{room.name}</b>?{' '}
        </p>

         <PercentBar
           percent={this.state.percent}
           onChange={(p) => this.setPercent(p)}
         />
      </div>
    );
  }

  renderReviewFields() {
    let room = this.room();
    return (
      <div className="review-body">
        <p>Tell us a bit more about <b>{room.name}</b>. (optional)</p>

        {this.renderFormGroup(null, 'textarea', 'body', { placeholder: 'Write your review here. No spoilers please!' })}

        {!this.state.showSpoilersField && <div>
         Want to review puzzles with spoilers? <Button bsSize="small" onClick={() => this.setState({ showSpoilersField: true })}>Add Spoiler Section</Button>
         </div>}
         {this.state.showSpoilersField && <div className="spoilers">
          <p>Spoiler section of the review:</p>
          {this.renderFormGroup(null, 'textarea', 'bodySpoilers', { placeholder: "Spoilers can go here, they'll be hidden by default" })}
          </div>}
      </div>
    );
  }
  
  setRoomId(room) {
    this.setState({ roomId: room.id, room: room });
  }

  setManual() {
    this.setState({
      roomId: null,
      room: null,
      manual: true,
    });
  }

  setRating(field, value) {
    let delta = {};
    delta[field] = value;
    this.setState(delta);
  }

  renderRatings() {
    let nodes = ratingFields.map(rf => {
      return <DetailRating
               key={rf[0]}
               data={this.state}
               ratingField={rf}
               onSetRating={(f, v) => this.setRating(f, v)}
             />
    });

    return (
      <div className="detail-ratings">
        {nodes}
      </div>
    );
  }

  renderButtons() {
    let step = this.step();

    console.log('RENDER BUTTONS', step);

    if (step == 'stars') {
      console.log('?');

      return (
        <div>
          <Button onClick={() => this.props.onCancel()}>Close</Button>
        </div>
      );
    }

    if (step == 'ratings') {
      console.log('??');

      return (
        <div>
          <Button bsSize="lg" onClick={() => this.props.onCancel()}>
            Cancel
          </Button>
          <Button key="continue" bsSize="lg" bsStyle="primary" onClick={() => this.setStep('body')}>
            Continue
          </Button>
        </div>
      );
    }

    if (step == 'body') {
      console.log('???');

      return (
        <div>
          <Button bsSize="lg" onClick={() => this.setStep('ratings')}>
            Back to Ratings
          </Button>
          <Button key="submit" bsSize="lg" bsStyle="primary" type="submit">
            Save Review
          </Button>
        </div>
      );
    }

    return super.renderButtons();
  }

  renderBody() {
    let room = this.room();
    let showAutocomplete = !room;

    let step = this.step();

    let showStars = ['stars', 'ratings', 'body'].includes(step)
    let showRatings = ['ratings'].includes(step);
    let showBody = ['body'].includes(step);

    console.log('debug showStars', showStars, step);

    return (
      <div className="ReviewForm">
        {showAutocomplete && <div>
         <div>Which room do you want to review?</div>
         <AutocompleteField
         getSuggestions={this.props.getSuggestions}
         onPick={v => this.setRoomId(v)}
         onManual={() => this.setManual()}
         />
         </div>
         }

        {room && showStars && this.renderStars()}
        {room && showRatings && this.renderRatings()}
        {room && showBody && this.renderReviewFields()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (...args) => dispatch(upload(...args)),
    getSuggestions: (...args) => dispatch(getSuggestions(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ReviewForm.js
 **/